<template>
  <div
    class="listScroll"
    ref="scrollRef"
    @touchstart="touchStart"
    @touchend="touchEnd"
  >
    <div>
      <slot></slot>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listLen'],
  data() {
    return {
      ele0: null,
      boxHeight: 0,
      isScroll: true,
      timer: null
    }
  },
  mounted() {
    console.log(this.boxHeight)
    this.init()
  },
  watch: {
    listLen() {
      this.$nextTick(() => {
        this.init()
      })
    }
  },
  methods: {
    init() {
      if (this.listLen <= 0) return
      this.ele0 = this.$refs.scrollRef.children[0]
      this.boxHeight = this.$refs.scrollRef.clientHeight
      if (this.boxHeight < this.ele0.clientHeight) {
        this.autoScroll()
      }
    },
    autoScroll() {
      if (!this.isScroll) return
      let scrollY = this.$refs.scrollRef.scrollTop
      if (scrollY >= this.ele0.clientHeight) {
        scrollY = 0
      } else {
        scrollY += 1
      }
      this.$refs.scrollRef.scrollTop = scrollY
      window.requestAnimationFrame(() => {
        this.autoScroll(scrollY)
      })
    },
    touchStart() {
      this.isScroll = false
    },
    touchEnd() {
      clearTimeout(this.timer)
      this.timer = null
      this.timer = setTimeout(() => {
        this.isScroll = true
        console.log(this.$refs.scrollRef.scrollTop, '---------------')
        this.autoScroll()
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
.listScroll {
  overflow: auto;
}
</style>
